import styled from 'styled-components'
import React from 'react'

const Container = styled.div`
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    padding: 0.25rem;
    color: ${props => props.theme.colors.grayDark};
    font-size: 0.75rem;
    cursor: pointer;
  }
`
export const Footer: React.VFC = () => {
  return (
    <Container>
      <span onClick={() => window.open('https://www.marketup.cn/', '_blank')}>本页面由 MarketUP 提供技术支持</span>
    </Container>
  )
}
